function UnsubscriptionNotification(id, reason) {
	this.id = id;
	this.reason = reason;
}

module.exports = UnsubscriptionNotification;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/unsubscription-notification/unsubscription-notification.js
// module id = 317
// module chunks = 1